<template src="./template.html"></template>
<style src="./styles.scss" lang="scss" scoped></style>

<script>
  export default {
    name: 'AppPagination',
    props: {
      'self': Number,
      'last': Number,
      'first': Number,
      'prev': [
        Number,
        Boolean,
      ],
      'next': [
        Number,
        Boolean,
      ],
      'query': [
        String,
        Boolean,
      ],
    },
    computed: {
      nextPageDisabled() {
        return this.self === this.last
      },
      prevPageDisabled() {
        return this.self === 1
      },
      routeNext() {
        const page = this.next || this.self
        const route = { query: { page } }
        if (this.query) {
          route.query.query = this.query
        }
        return route
      },
      routePrev() {
        const page = this.prev || this.self
        const route = { query: { page } }
        if (this.query) {
          route.query.query = this.query
        }
        return route
      },
    },
  }
</script>
